import React, { useEffect, useState } from "react";
import apiService from "../../../apiService";
import moment from 'moment'
import Table from "../../component/Table1";
import ApiService from "../../../apiService";
import { showLoading, toast } from "../../component/Alert";

export default function Sdidtk({ detilPx }) {

    const [px, setPx] = useState(detilPx)
    const [interpretations, setInterpretations] = useState([])
    const [questions, setQuestions] = useState([])
    const [showQuestionForm, setShowQuestionForm] = useState(false)

    useEffect(() => {
        getInterpretations()
    }, [])

    const getInterpretations = async () => {
        showLoading("Mendapatkan Data");
        const res = await ApiService.get(`management/kpsp/interpretation/${px.patient_id}`)
        toast({ status: "success", text: "Data Ditemukan" });
        if (res.success) {
            setInterpretations(res.data)
        }
    }

    const getQuestions = async () => {
        showLoading("Mendapatkan Data");
        const res = await ApiService.get(`management/kpsp/questions/` + getAgeMonth(px.patients.birth_date))
        // const res = await ApiService.get(`management/kpsp/questions/${getAgeMonth(px.patients.birth_date)}`)
        toast({ status: "success", text: "Data Ditemukan" });
        if (res.success) {
            setQuestions(res.data)
        }
    }

    const getData = async () => {
        let param = {
            keyword: {
                visitId: px.id,
            },
            limit: 10,
            frDate: "",
            enDate: "",
        };

        const res = await apiService.post("registration", param);
        if (res?.status === "success.") {
            setPx(res.data.data[0])
        }
    }

    const getAgeMonth = (birthdate) => {
        const datebirtdate = moment(birthdate).format('YYYY-MM-DD');
        const dateNow = moment().format('YYYY-MM-DD');
        return moment(dateNow).diff(datebirtdate, 'months', false);
    }

    const isiForm = async () => {
        if (!questions.length) {
            await getQuestions()
        }
        else {
            setQuestions(questions.map(v => ({ ...v, checked: false })))
        }
        setShowQuestionForm(true)
    }

    const saveAnswers = async answers => {
        showLoading("Menyimpan Jawaban");
        const res = await ApiService.post(`management/kpsp/answer`, {
            visit_id: px.id,
            patient_id: px.patient_id,
            month: getAgeMonth(px.patients.birth_date),
            answers
        })
        toast({ status: "success", text: "Berhasil menyimpan jawaban" });
        if (res.success) {
            setShowQuestionForm(false)
            await getInterpretations()
        }
    }

    return (
        <div>
            <div className='card'>
                <div className='card-header'>
                    <div className='row align-items-center'>
                        <div className='col'>
                            <span className='h3 mb-0 '>Form SDIDTK (Simulasi Deteksi Intervensi Dini Tumbuh Kembang)</span>
                            <span className='ml-2 mt--1'>
                                <a
                                    className='btn btn-sm btn-twitter btn-icon-only rounded-circle'
                                    onClick={getData}>
                                    <i
                                        className='fa fa-refresh'
                                        style={{ color: "white" }}
                                        aria-hidden='true'></i>
                                </a>
                            </span>
                        </div>
                        <div className={'badge badge-pill badge-success'}>
                            <b>{getAgeMonth(px.patients.birth_date)} Bulan</b>
                        </div>
                    </div>
                </div>
                <div className='card-body'>
                    {!showQuestionForm && <ListForm interpretations={interpretations} isiForm={isiForm} />}
                    {showQuestionForm && <QuestionForm questions={questions} onSave={saveAnswers} onCancel={() => setShowQuestionForm(false)} />}
                </div>
            </div>
        </div>
    )
}

const ListForm = ({ interpretations, isiForm }) => <>
    <div style={{ display: 'flex', justifyContent: 'end' }}>
        <button className={'btn btn-success mb-2'} onClick={isiForm}>
            Isi Form
        </button>
    </div>
    <Table
        className="table table-responsive"
        headers={[
            "No",
            "Bulan",
            "Interpretasi",
            "Jawaban Ya",
        ]}
        data={interpretations}
        columnMapper={(a, key) => [
            a.month,
            a.interpretation === 'S' ? <div className={'badge badge-pill badge-success'}>Sesuai Umur</div> :
                a.interpretation === "M" ? <div className={'badge badge-pill badge-warning'}>Meragukan</div> :
                    <div className={'badge badge-pill badge-danger'}>Penyimpangan</div>,
            a.yes_count,
        ]}
        issearch={false}
        pagination={false}
    />
</>

const QuestionForm = ({ questions, onSave, onCancel }) => {
    console.log({ questions })
    return <div>
        {questions.map((v, k) => (
            <div key={`q-${k}`} style={{
                border: '1px solid #eeeeee',
                borderRadius: 8,
                margin: 10,
                display: 'flex',
                flexDirection: 'column'
            }}>
                <span style={{
                    background: '#2F82EE',
                    padding: 12,
                    color: 'white',
                    borderTopRightRadius: 8,
                    borderTopLeftRadius: 8,
                    fontWeight: 'bold'
                }}>
                    #{v.order} {v.category}
                </span>
                <div style={{ padding: 12, }}>
                    {v.question}
                    <br />
                    {v.image && <img alt={''} src={`${process.env.REACT_APP_SERVER_URL}/storage/images/${v.image}`} />}
                </div>
                <div style={{
                    padding: 12,
                    borderTop: '1px solid #eeeeee',
                    display: 'flex',
                    alignItems: 'center'
                }}>
                    <span className={'mr-2'}>Jawaban</span>
                    <label className="custom-toggle custom-toggle-success">
                        <input
                            type="checkbox"
                            checked={v.checked}
                            onChange={(e) => {
                                v.checked = e.target.checked
                            }}
                        />
                        <span
                            className="custom-toggle-slider rounded-circle"
                            data-label-off="Tidak"
                            data-label-on="Ya"
                        />
                    </label>
                </div>
            </div>
        ))}
        <div style={{ display: 'flex', justifyContent: 'end' }}>
            <button
                className={'btn btn-success'}
                onClick={() => {
                    const ans = questions.map(v => ({
                        kpsp_question_id: v.id,
                        answer: v.checked ? 'Ya' : 'Tidak'
                    }))
                    onSave(ans)
                }}>
                Simpan
            </button>
            <button className={'btn btn-danger'} onClick={onCancel}>Batal</button>
        </div>
    </div>
}